module.exports = __webpack_public_path__ + "media/components/country-flag/static/lc-ed876b81770aae338cfe2bd57a0cf386.svg";